import { createAction } from 'redux-actions';
import * as actionTypes from './constants';

export const fetchUsers = createAction(actionTypes.FETCH_USERS);
export const fetchUsersSuccess = createAction(actionTypes.FETCH_USERS_SUCCESS);
export const fetchUsersFailure = createAction(actionTypes.FETCH_USERS_FAILURE);

export const fetchRestrictedUsers = createAction(actionTypes.FETCH_RESTRICTED_USERS);
export const fetchRestrictedUsersSuccess = createAction(actionTypes.FETCH_USERS_RESTRICTED_SUCCESS);
export const fetchRestrictedUsersFailure = createAction(actionTypes.FETCH_USERS_RESTRICTED_FAILURE);

export const clearUsersData = createAction(actionTypes.CLEAR_USERS_DATA);
